import moment from 'moment';
import React from 'react';
import { Typography, Grid, Stack, InputLabel, TextField, Select, MenuItem, Button } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { BorderedPagePanel } from 'Components/Styled';
import MicroContentList from './MicroContentList';
import MicroContentViewPanel from './MicroContentViewPanel';
import { saveMicroExperienceForCustomer } from '../../../Services/Microexperiences';

export default function MicroExperienceEditForm({ mx={}, experienceDate, customer, onSave, onCancel, mode }) {
    const [activeMX, setActiveMX] = React.useState(mx);
    const [collapseContent] = React.useState(false);
    const [activeContent, setActiveContent] = React.useState(mx.microContent || {});
    const [activeDate, setActiveDate] = React.useState(experienceDate);
    const [doSubmit, setDoSubmit] = React.useState(false);

    React.useEffect(() => {
        setActiveMX((activeMX) => ({ ...activeMX, internalStatus:"PENDING", customerStatus:"PENDING" }))
    }, []);

    React.useEffect(() => {
        setActiveDate(moment(experienceDate));
    }, [experienceDate]);

    function setExperienceDate(date) {
        setActiveMX({ ...activeMX, experienceDate: moment(date).toISOString() });
        setActiveDate(date);
    }

    function setDeliveryType(deliveryType) { setActiveMX({ ...activeMX, deliveryType }); }
    function setInternalStatus(internalStatus) { setActiveMX({ ...activeMX, internalStatus }); }
    function setCustomerStatus(customerStatus) { setActiveMX({ ...activeMX, customerStatus }); }

    function saveMicroExperience() {
        console.log({ activeMX });       
        if (!activeMX.variation) { alert('Please assign a content variation before saving'); return }
        if (!activeMX.deliveryType) { alert('You must select a delivery type'); return}
        setDoSubmit(true);

        const { contentList, experienceImage, ...parsedContent } = activeMX.microContent;

        const data = {
            user_id : customer.profile.id,
            customer_status : activeMX.customerStatus,
            internal_status : activeMX.internalStatus,
            delivery_type : activeMX.deliveryType,
            display_name : activeMX.microContentName,
            effort_size : activeMX.effortSize,
            effort_value : activeMX.effortValue,
            aex_micro_content_id : activeMX.microContentId,
            aex_micro_content_variation_code : activeMX.variationCode,
            micro_content_cache : JSON.stringify(parsedContent),
            micro_content_variation_cache : JSON.stringify(activeMX.variation),
            scheduled_date : activeDate,
        };

        saveMicroExperienceForCustomer(customer.profile.id, data)
        .then(response => {
            console.log('SUCCESS : ', response)
            onSave(activeMX);
        })
        .catch(err => {
            console.log('ERROR : ', err);
            setDoSubmit(false);
        })

        
    }

    function cancelMicroExperience() { onCancel(mx); }

    function onSelectMicroContent(microContent, variation) {
        setActiveContent({ microContent, variation });
        
        setActiveMX({ 
            ...activeMX, 
            microContentName: microContent.name,
            effortSize : microContent.effortSize,
            effortValue : microContent.effortValue,
            microContentId: microContent.id, 
            variationCode: variation.code, 
            microContent: microContent, 
            variation: variation });
    }
    function updateMessageContent(messageContent) { setActiveMX({ ...activeMX, messageContent }); }
    function updateInternalNote(internalNote) { setActiveMX({ ...activeMX, internalNote }); }
    function updateFeedback(feedback) { setActiveMX({ ...activeMX, feedback }); }

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <BorderedPagePanel>
                <Grid container spacing={1} flex={1}>
                    <Grid item xs={9}>
                        {' '}
                        <Typography variant={'h2'}>Microexperience Details</Typography>{' '}
                    </Grid>
                    <Grid item xs={3}>
                        <Stack direction="row">
                            <Button
                                sx={{ width: 1 / 2 }}
                                variant="contained"
                                color="primary"
                                onClick={saveMicroExperience}
                                disabled={doSubmit}
                            >
                                Save MX
                            </Button>
                            <Button
                                sx={{ width: 1 / 2 }}
                                variant="contained"
                                color="secondary"
                                onClick={cancelMicroExperience}
                            >
                                Cancel
                            </Button>
                        </Stack>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel id="mx-date-label">Date</InputLabel>
                        <DatePicker
                            fullWidth
                            labelId={'mx-date-label'}
                            value={activeDate}
                            onChange={(newValue) => setExperienceDate(newValue)}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel id="mx-delivery-label">Delivery *</InputLabel>
                        <Select
                            fullWidth
                            displayEmpty
                            labelId="mx-delivery-label"
                            value={activeMX.deliveryType || ''}
                            onChange={(e) => setDeliveryType(e.target.value)}
                        >
                            <MenuItem value="">-- SELECT --</MenuItem>
                            <MenuItem value="SMS">SMS</MenuItem>
                            <MenuItem value="Email">Email</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel id="mx-internal-status-label">Internal Status</InputLabel>
                        <Select
                            fullWidth
                            labelId="mx-internal-status-label"
                            value={activeMX.internalStatus || 'PENDING'}
                            onChange={(e) => setInternalStatus(e.target.value)}
                        >
                            <MenuItem value="PENDING">Pending</MenuItem>
                            <MenuItem value="SENT">Sent</MenuItem>
                            <MenuItem value="DONE">Complete</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel id="mx-cx-status-label">Customer Status</InputLabel>
                        <Select
                            fullWidth
                            labelId="mx-cx-status-label"
                            value={activeMX.customerStatus || 'PENDING'}
                            onChange={(e) => setCustomerStatus(e.target.value)}
                        >
                            <MenuItem value="PENDING">Pending</MenuItem>
                            <MenuItem value="SENT">Sent</MenuItem>
                            <MenuItem value="DONE">Complete</MenuItem>
                        </Select>
                    </Grid>
                </Grid>

                {!activeContent.microContent && (
                    <BorderedPagePanel sx={{ boxShadow: 5, mt: 2 }}>
                        <MicroContentList onSelectMicroContent={onSelectMicroContent} />
                    </BorderedPagePanel>
                )}

                {!!activeContent.microContent && (
                    <Stack direction="column">
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                Customer Message
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={6}
                                    value={activeMX.messageContent}
                                    onChange={(e) => updateMessageContent(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                Notes
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={6}
                                    value={activeMX.internalNote}
                                    onChange={(e) => updateInternalNote(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                Feedback
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={6}
                                    value={activeMX.feedback}
                                    onChange={(e) => updateFeedback(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                Template
                            </Grid>
                            <Grid item xs={9}>
                                <MicroContentViewPanel
                                    mx={activeMX}
                                    variation={activeContent.variation}
                                    microContent={activeContent.microContent}
                                    collapse={collapseContent}
                                />
                            </Grid>
                        </Grid>
                    </Stack>
                )}
            </BorderedPagePanel>
        </LocalizationProvider>
    );
}
